import type { FC } from 'react';
import classNames from 'classnames';
import styles from '../analytics.module.scss';
import type { MetricKey } from '../lib/helpers';
import { Flex } from 'antd';
import { Text } from '@shared/ui/antd';

type MetricOption = { key: MetricKey; label: string; total: number };

type Props = {
  value: MetricKey;
  options: MetricOption[];
  onChange: (next: MetricKey) => void;
};

export const MetricSwitch: FC<Props> = ({ value, options, onChange }) => {
  return (
    <div className={styles.metricSwitch}>
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          className={classNames(styles.metricBtn, {
            [styles.metricBtn_active]: value === opt.key,
          })}
          onClick={() => onChange(opt.key)}
        >
          <Flex vertical gap={12} align="start">
            <Text variant="md" fontWeight={400} className={styles.metricLabel}>
              {opt.label}
            </Text>

            <Text variant="xl" fontWeight={500} className={styles.metricTotal}>
              {opt.total}
            </Text>
          </Flex>
        </button>
      ))}
    </div>
  );
};
